import { Table as MantineTable } from "@mantine/core";
export function MensTopsTable() {
  return (
    <MantineTable>
      <MantineTable.Thead>
        <MantineTable.Tr>
          <MantineTable.Th>Size (KURB)</MantineTable.Th>
          <MantineTable.Th>IT/FR</MantineTable.Th>
          <MantineTable.Th>US/UK</MantineTable.Th>
          <MantineTable.Th>JP</MantineTable.Th>
        </MantineTable.Tr>
      </MantineTable.Thead>
      <MantineTable.Tbody>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXS</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXS</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXS</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
          <MantineTable.Td>30</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXS</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
          <MantineTable.Td>32</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XS</MantineTable.Td>
          <MantineTable.Td>44</MantineTable.Td>
          <MantineTable.Td>34</MantineTable.Td>
          <MantineTable.Td>0</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>S</MantineTable.Td>
          <MantineTable.Td>46</MantineTable.Td>
          <MantineTable.Td>36</MantineTable.Td>
          <MantineTable.Td>1</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>M</MantineTable.Td>
          <MantineTable.Td>48</MantineTable.Td>
          <MantineTable.Td>38</MantineTable.Td>
          <MantineTable.Td>2</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>L</MantineTable.Td>
          <MantineTable.Td>50</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XL</MantineTable.Td>
          <MantineTable.Td>52</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
          <MantineTable.Td>4</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXL</MantineTable.Td>
          <MantineTable.Td>54</MantineTable.Td>
          <MantineTable.Td>44</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXL</MantineTable.Td>
          <MantineTable.Td>56</MantineTable.Td>
          <MantineTable.Td>46</MantineTable.Td>
          <MantineTable.Td>6</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXL</MantineTable.Td>
          <MantineTable.Td>58</MantineTable.Td>
          <MantineTable.Td>48</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXL</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXXL</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
        </MantineTable.Tr>
      </MantineTable.Tbody>
    </MantineTable>
  );
}
